import { render, staticRenderFns } from "./OrderActivityCardDetail.vue?vue&type=template&id=76d48781&"
import script from "./OrderActivityCardDetail.vue?vue&type=script&lang=js&"
export * from "./OrderActivityCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderActivityCardDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports